import { CFImage } from '@/data/portfolio/type/client-index'
import classNames from 'classnames'
import Image from 'next/image'

export type ImageTopDescriptionBottomProps = {
  image: CFImage
  description: string
  width: number
  title?: string
  subtitle?: string
  reversed?: boolean
}

export default function ImageTopDescriptionBottom({
  image,
  description,
  width,
  title,
  subtitle,
  reversed = false
}: ImageTopDescriptionBottomProps) {
  return (
    <>
      <div className="px-6 md:h-full md:max-h-[62rem] md:px-0 md:py-24 md:pr-12">
        <div
          className={classNames('container flex h-full justify-start space-y-8', {
            'flex-col': !reversed,
            'flex-col-reverse space-y-reverse': reversed
          })}>
          <div className="w-full">
            <Image src={image.url} width={image.width} height={image.height} />
          </div>
          <div>
            {title ? <h2 className="font-serif text-5xl font-bold">{title}</h2> : null}
            {subtitle ? <h2 className="text-lg font-medium uppercase">{subtitle}</h2> : null}
            <p className="hyphenate mt-4 max-w-lg font-light leading-relaxed">{description}</p>
          </div>
        </div>
      </div>
      <style jsx>{`
        @media (min-width: 768px) {
          .container {
            max-width: ${width}rem;
          }
        }
      `}</style>
    </>
  )
}
